// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./event-info/styles.scss
// module id = 933
// module chunks = 0